import { keyBy } from 'lodash';
import ConstCommon from '../../../common/Const';
import { getParamFromSortState, getQueryParams } from '../../../helpers/Common';
import CurrentState from '../../../helpers/CurrentState';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import priceVolumeService from '../../../../core/services/Technical/PriceVolumeService';
import Const from '../../ta-signals/price-volume/Const';
import Interval from '../../../helpers/IntervalCallApi';

const REDUCER_NAME = 'PRICE_VOLUME:';
const FETCH_LOAD_LIST_PRICE_VOLUME = `${REDUCER_NAME}FETCH_LOAD_LIST_PRICE_VOLUME`;
const CHANGE_PRICE_VOLUME_LIST = `${REDUCER_NAME}CHANGE_PRICE_VOLUME_LIST`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const FETCH_DATA = `${REDUCER_NAME}FETCH_DATA`;
const LOAD_MORE_PRICE_VOLUME = `${REDUCER_NAME}LOAD_MORE_PRICE_VOLUME`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SUBSCRIBE_REALTIME_TICK_PRICE_VOLUME = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK_PRICE_VOLUME`;

export {
  REDUCER_NAME,
  reducer as default,
  changeFeatureDropDown,
  intervalFetchPriceVolume,
  loadMorePriceVolume,
  subscribeRealtimeTickPriceVolume,
  cancelfetchDataPriceVolume,
};

const initialState = {
  listTickerPriceVolume: [],
  listPriceVolumeByTicker: {},
  code: Const.defaultCode,
  indexData: {},
  id: '',
  featureType: Const.defaultOption,
  isLoading: false,
  priceVolumeId: 0,
  totalPage: 10,
  checkFlag: 0,
  firstPage: 0,
  lstTickerLoadMore: [],
  lstTickerLoadMoreByTicker: {},
  component: {},
};

function changeFeatureDropDown(featureType) {
  return dispatch => {
    dispatch({
      type: CHANGE_PRICE_VOLUME_LIST,
      payload: {
        featureType,
      },
    });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function subscribeRealtimeTickPriceVolume(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK_PRICE_VOLUME,
    payload: {
      data,
    },
  };
}

function cancelfetchDataPriceVolume() {
  return () => {
    Interval.cancel('PriceVolume');
  };
}

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const featureTypeFromQuery = getQueryParams('option');

      return {
        ...state,
        ...initialState,
        featureType:
          featureTypeFromQuery ||
          CurrentState.get(
            ConstCommon.listComponent.TASignals,
            'priceVolumeDropdown',
          ) ||
          Const.defaultOption,
      };
    case UNMOUNT_COMPONENT:
      return {};
    case FETCH_LOAD_LIST_PRICE_VOLUME: {
      const { listPriceVolume } = action.payload;
      let id = 0;
      listPriceVolume.forEach(items => {
        items.idPriceVolume = id++;
      });
      const listPriceVolumeByTicker = keyBy(listPriceVolume, Const.organCode);
      const listTickerPriceVolume = listPriceVolume.map(item => item.organCode);
      return {
        ...state,
        listTickerPriceVolume,
        listPriceVolumeByTicker,
        priceVolumeId: id,
      };
    }
    case CHANGE_PRICE_VOLUME_LIST: {
      const featureType = action.payload.featureType;
      return { ...state, featureType };
    }
    case SET_LOADING: {
      return { ...state, isLoading: action.payload };
    }
    case FETCH_DATA: {
      return { ...state, isLoading: action.payload };
    }
    case LOAD_MORE_PRICE_VOLUME: {
      const { listWatchListLoadMore, priceVolumeId } = action.payload;
      let id = priceVolumeId;
      listWatchListLoadMore.forEach(items => {
        items.idPriceVolume = id++;
      });
      const lstTickerLoadMore = listWatchListLoadMore.map(
        item => item.organCode,
      );
      const lstTickerLoadMoreByTicker = keyBy(
        listWatchListLoadMore,
        Const.organCode,
      );
      return {
        ...state,
        listTickerPriceVolume: [
          ...state.listTickerPriceVolume,
          ...lstTickerLoadMore,
        ],

        listPriceVolumeByTicker: {
          ...state.listPriceVolumeByTicker,
          ...lstTickerLoadMoreByTicker,
        },
        isFetching: false,
        priceVolumeId: id,
        firstPage: 0,
      };
    }

    case SUBSCRIBE_REALTIME_TICK_PRICE_VOLUME: {
      const listPriceVolumeByTickerNew = {
        ...state.listPriceVolumeByTicker,
      };
      action.payload.data.forEach(item => {
        if (listPriceVolumeByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listPriceVolumeByTickerNew[item.organCode],
          };
          if (tickerItem) {
            tickerItem.totalMatchedVolume = item.totalMatchVolume;
            tickerItem.totalMatchVolume = item.totalMatchVolume;
            tickerItem.matchPrice = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
          }
          listPriceVolumeByTickerNew[item.organCode] = tickerItem;
        }
      });
      return {
        ...state,
        listPriceVolumeByTicker: listPriceVolumeByTickerNew,
      };
    }

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    default:
      return state;
  }
}

function intervalFetchPriceVolume(featureType, sortState) {
  return dispatch => {
    dispatch(setLoading(true));
    Interval.fetch(
      'PriceVolume',
      dispatch,
      function(source) {
        const params = {
          PriceVolumeAnalysis: featureType,
          Page: 1,
          PageSize: Const.maxRowData,
          ...getParamFromSortState(sortState, {
            rank: 'Rank',
            organCode: 'Ticker',
          }),
        };
        if (featureType) params.PriceVolumeAnalysis = featureType;
        return priceVolumeService.getListPriceVolume(params, source);
      },
      function(response) {
        const { items = [] } = response.items === null ? [] : response;
        dispatch({
          type: FETCH_LOAD_LIST_PRICE_VOLUME,
          payload: {
            listPriceVolume: items,
          },
        });
        dispatch(setLoading(false));
      },
      1000 * 30,
      err => dispatch(setLoading(false)),
    );
  };
}

function formatedParams(params) {
  const formatParams = {
    Page: params.priceVolumeId || 1,
    PageSize: params.PageSize || Const.maxRowData,
  };
  if (params.featureType) formatParams.featureType = params.featureType;

  return formatParams;
}

function loadMorePriceVolume(params) {
  return dispatch => {
    dispatch(setLoading(true));
    const formatParams = formatedParams(params);
    const priceVolumeId = params.priceVolumeId;
    priceVolumeService
      .getListPriceVolume(formatParams)
      .then(response => {
        const { items = [] } = response.items === null ? [] : response;
        if (!items) return;
        dispatch({
          type: LOAD_MORE_PRICE_VOLUME,
          payload: {
            listWatchListLoadMore: items || [],
            priceVolumeId,
          },
        });
        dispatch(setLoading(false));
      })
      .catch(err => dispatch(setLoading(false)));
    dispatch({
      type: FETCH_DATA,
      payload: true,
    });
  };
}

reducerRegistry.register(REDUCER_NAME, reducer);
